"use client";

import { useState } from "react";

import { createSupabaseBrowserClient } from "@/lib/supabase/client";

export default function WaitlistLanding() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");
    setMessage("");
    try {
      const sb = createSupabaseBrowserClient();
      const normalized = email.trim().toLowerCase();
      const { error } = await sb.from("waitlist_signups").insert({ email: normalized });
      if (error) {
        if (error.code === "23505") {
          setStatus("success");
          setMessage("You’re already on the list — we’ll be in touch.");
          setEmail("");
          return;
        }
        setStatus("error");
        setMessage(error.message || "Something went wrong.");
        return;
      }
      setStatus("success");
      setMessage("You’re in. We’ll email you when it’s ready.");
      setEmail("");
    } catch {
      setStatus("error");
      setMessage("Check your connection and try again.");
    }
  };

  return (
    <main className="mx-auto flex w-full max-w-lg flex-1 flex-col justify-center px-4 pb-16 pt-10 sm:px-6 sm:pb-20 sm:pt-16">
      <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-violet-600">crshm</p>
      <h1 className="mt-3 text-center text-3xl font-black leading-tight tracking-tight text-zinc-900 sm:text-4xl">
        We&apos;re cooking up something special.
      </h1>
      <p className="mx-auto mt-4 max-w-md text-center text-sm leading-relaxed text-zinc-600 sm:text-base">
        Be the first to know when we&apos;re done — drop your email and we&apos;ll ping you.
      </p>

      <form onSubmit={(e) => void onSubmit(e)} className="mx-auto mt-10 w-full max-w-md space-y-3">
        <label htmlFor="waitlist-email" className="sr-only">
          Email
        </label>
        <input
          id="waitlist-email"
          type="email"
          name="email"
          autoComplete="email"
          inputMode="email"
          placeholder="you@email.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (status !== "idle") setStatus("idle");
          }}
          disabled={status === "loading"}
          className="min-h-12 w-full rounded-xl border border-violet-200 bg-white px-4 py-3 text-base text-zinc-900 shadow-sm outline-none ring-violet-400 placeholder:text-zinc-400 focus:ring-2 disabled:opacity-60 sm:text-sm"
        />
        <button
          type="submit"
          disabled={status === "loading" || !email.trim()}
          className="min-h-12 w-full rounded-xl bg-violet-600 px-4 py-3 text-sm font-bold text-white shadow-md transition hover:bg-violet-700 active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-50"
        >
          {status === "loading" ? "Saving…" : "Notify me"}
        </button>
      </form>

      {message ? (
        <p
          className={`mx-auto mt-4 max-w-md text-center text-sm font-medium ${
            status === "error" ? "text-rose-600" : "text-emerald-700"
          }`}
        >
          {message}
        </p>
      ) : null}

      <p className="mx-auto mt-10 max-w-sm text-center text-[11px] leading-relaxed text-zinc-500">
        Do or Dump is in the menu — this page is just the heads-up list.
      </p>
    </main>
  );
}
